import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import styles from './styles.module.scss';

import apiLocation from '../../api/Location';
import { spanish } from '../../config/config';
// import data from '../../static/location/index.json';
import image from '../../assets/images/map';
import { ReactComponent as Arrow } from '../../assets/icons/icon-arrow-down.svg';

const MobileSelector = ({ continents, selectContinent }) => {
  const options = continents?.map((item) => item.name);
  const output = (
    <div className={styles.mobileSelector}>
      <label>
        <select onChange={(e) => selectContinent(e.target.value)}>
          <option value="" defaultValue>
            Selecciona región e idioma
          </option>
          {options.map((item, key) => (
            <option value={item} key={key}>
              {item}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
  return output;
};

const DesktopSelector = ({ continents, selectContinent, continent }) => {
  const options = continents?.map((item) => item.name);
  const output = (
    <div className={styles.desktopSelector}>
      {options.map((item, key) => (
        <button
          type="button"
          key={key}
          onClick={() => selectContinent(item)}
          className={continent === item ? styles.buttonActive : ''}
        >
          <span>{item}</span>
          <i />
        </button>
      ))}
    </div>
  );
  return output;
};

const Map = ({ continent }) => {
  let selected = image.blank;
  if (continent === 'Africa') selected = image.africa;
  else if (continent === 'Asia') selected = image.asia;
  else if (continent === 'Caribe') selected = image.caribe;
  else if (continent === 'América Latina') selected = image.latam;
  else if (continent === 'Europa') selected = image.europe;
  else if (continent === 'Medio Oriente') selected = image.middle;
  else if (continent === 'Norte América') selected = image.north;
  else if (continent === 'Costa del Pacífico') selected = image.pacific;
  const output = (
    <div className={styles.menuMap}>
      <picture>
        <img src={selected} alt={continent} />
      </picture>
    </div>
  );
  return output;
};

const Menu = ({ continents, selectContinent, continent, isMobile }) => (
  <div className={styles.menu}>
    {isMobile ? (
      <div className={styles.menuMobile}>
        <MobileSelector
          continents={continents}
          selectContinent={selectContinent}
        />
        <Map continent={continent} />
      </div>
    ) : (
      <div className={styles.menuDesktop}>
        <DesktopSelector
          continents={continents}
          selectContinent={selectContinent}
          continent={continent}
        />
        <Map continent={continent} />
      </div>
    )}
  </div>
);

const List = ({ continents, continent }) => {
  const selectedContinent = continents?.find((item) => item.name === continent);
  const countries = selectedContinent?.countries.map((item, key) => {
    const [show, setShow] = useState(false);
    const list = (
      <li key={key} className={styles.listItem}>
        <button
          type="button"
          onClick={() => setShow(!show)}
          onBlur={() => setShow(false)}
        >
          <p>{item.name}</p>
          <Arrow />
        </button>
        {show && (
          <div className={styles.itemPopup}>
            {item.languages?.map((language, index) => (
              <a
                href={language.link}
                key={index}
                target="_blank"
                rel="noreferrer noopener"
              >
                {language.name}
              </a>
            ))}
          </div>
        )}
      </li>
    );
    return list;
  });
  const output = (
    <div className={styles.list}>
      <ul className={styles.listContainer}>{countries}</ul>
    </div>
  );
  return output;
};

const Location = () => {
  const [data, setData] = useState(null);
  useEffect(async () => {
    setData(await apiLocation.getContent());
  }, []);
  const [continent, setContinent] = useState('');
  const selectContinent = (value) => setContinent(value);
  const [viewport, setViewport] = useState(window.innerWidth);
  useEffect(() => {
    const handleWindowResize = () => setViewport(window.innerWidth);
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);
  const isMobile = viewport < 620;
  const output = (
    <div className={styles.container}>
      <Helmet title={spanish ? 'Países' : 'Countries'} />
      <h3>
        {spanish ? 'Seleccionar región e idioma' : 'Select region and language'}
      </h3>
      {data?.map?.continents && (
        <Menu
          continents={data?.map?.continents}
          selectContinent={selectContinent}
          continent={continent}
          isMobile={isMobile}
        />
      )}
      {data?.map?.continents && (
        <List continents={data?.map?.continents} continent={continent} />
      )}
    </div>
  );
  return output;
};

export default Location;
